import { Dialog, DialogContent } from '@/components/ui/dialog';
import { useAuth0 } from '@auth0/auth0-react';
import { UserCheck, Users } from 'lucide-react';
import { FC } from 'react';
import { Button } from './ui/button';

interface Props {
  isOpen: boolean;
  setIsOpen: () => void;
}

const RegisterAccountModal: FC<Props> = ({ isOpen, setIsOpen }) => {
  const { loginWithRedirect } = useAuth0();

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-md">
        <div className="p-6 rounded-lg text-center">
          <h3 className="text-xl font-medium mb-2">Hey there! 👋</h3>
          <br />
          <p>
            Let’s get you signed in or create a quick account so we know it’s
            you.
          </p>
          <div className="flex flex-col gap-4 mt-6">
            <Button
              onClick={() =>
                loginWithRedirect({
                  appState: {
                    returnTo: '/help',
                  },
                })
              }
              className="bg-primary hover:bg-primary/90 text-primary-foreground py-6 text-lg font-medium flex items-center justify-center gap-3"
            >
              <UserCheck className="w-5 h-5" />
              Login
            </Button>

            <Button
              onClick={() =>
                loginWithRedirect({
                  appState: {
                    returnTo: '/help',
                  },
                  authorizationParams: {
                    screen_hint: 'signup',
                  },
                })
              }
              variant="outline"
              className="border-tax-borderGray hover:bg-tax-lightGray text-tax-neutralGray hover:text-tax-deepBlue py-6 text-lg font-medium flex items-center justify-center gap-3"
            >
              <Users className="w-5 h-5" />
              Create Account
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RegisterAccountModal;
